import axios from "axios";
//允许跨域携带Cooke
axios.defaults.withCredentials = true;

axios.yuming=ipObj[ipIndex].address;
var ipPort = "http://" + ipObj[ipIndex].ip + ipObj[ipIndex].port
axios.imUrl = "ws://" + ipObj[ipIndex].ip + ipObj[ipIndex].imPort + "/gps-server-im";//websocket
axios.defaults.baseURL = ipPort + "/gps-server-admin";


//平台web服务
axios.serverWeb = ipPort + "/gps-server-web";

//日志中心
axios.gpsLogger = ipPort + "/gps-logger";

//报表服务
axios.report = ipPort + "/gps-server-report";

//趟次服务
axios.times = ipPort + "/gps-server-times";

//调度服务
axios.dispatch = ipPort + "/gps-server-dispatch";
//位置服务
axios.lbs = ipPort + "/gps-server-lbs";
//指令
axios.cmd = ipPort + "/gps-server-cmd";
axios.interceptors.request.use(
  function (config) {
    var json = JSON.parse(localStorage.getItem("phone"));
    axios.keyObj = json;
    //console.log(json)
    if (json != null) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.share = json.share;
      config.headers.token = json.token;
      config.headers.identityId = json.identityId;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  function (res) {

    // 对响应数据做点什么
    if (res.data.code == 400) {
      return res;
    } else if (res.data.code == 500) {
      alert("系统异常（500）");
      return res;
    } else if (res.data.code == 800) {
      //console.log(res.config.url);
      // alert(res.config.url+"没有权限");
      return res;
    } else if (res.data.code == 701) {
      localStorage.removeItem("phone");
      window.location.reload(); //刷新页面
    } else if (res.data.code == 200) {
      return res;
    }
    return res;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);



//////////////////
// WEBPACK FOOTER
// ./config/axios.js
// module id = null
// module chunks = 